<template>
  <div class="index-container">
    <div class="index-center-box">
      <div class="index-collect-box">
        <div class="index-collect-title jee-bg-primary">
          <jee-icon iconClass="kuaisucaiji" :style="{fontSize: '32px', color: '#fff', fill: '#fff', marginRight: '10px'}"></jee-icon>快速采集
        </div>
        <div class="index-collect-bottom">
          <div class="index-collect-tip">
            <p>选用系统内置采集模板，无需设置， 快速采集主流网站数据</p>
          </div>
          <div class="index-collect-button">
            <el-button type="primary" @click="goTo('FastCollect')">创建任务</el-button>
          </div>
        </div>
      </div>
      <div class="index-collect-box" v-if="true">
        <div class="index-collect-title jee-bg-primary">
          <jee-icon iconClass="zidingyicaiji" :style="{fontSize: '32px', color: '#fff', fill: '#fff', marginRight: '10px'}"></jee-icon>自定义采集
        </div>
        <div class="index-collect-bottom">
          <div class="index-collect-tip">
            <p>可以智能分析网页结构，自定义采集数据，通用且功能强大</p>
          </div>
          <div class="index-collect-button">
            <el-button type="primary" @click="goTo('CustomCollect')">创建任务</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'index',
  methods: {
    goTo (name) {
      this.$router.push({ name: name })
    }
  }
}
</script>

<style lang="scss">
.index-container{
  position: relative;
  height: 100%;
  .index-center-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
  }
 .index-collect-box{
   width: 280px;
   border-radius: 4px;
   overflow: hidden;
   margin: 0 37px;
   .index-collect-title{
     height:150px;
     font-size:30px;
     color: #fff;
     text-align: center;
     line-height: 150px;
   }
   .index-collect-bottom{
     background:rgba(249,249,249,1);
     text-align: center;
     padding: 30px 0;
     .index-collect-tip{
       width:215px;
       margin: 0 auto;
       font-size:14px;
       font-family:Microsoft YaHei;
       font-weight:300;
       color:rgba(102,102,102,1);
       line-height:28px;
     }
     .index-collect-button{
       margin-top: 30px;
       /deep/ .el-button{
         font-size: 16px;
       }
     }
   }
 }
}
</style>
